import { Component } from '@angular/core';
import { NgbModalConfig, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { PersonalAbsenceService } from '../../../../../core/services/personal-absence.service';
import { PersonalService } from '../../../../../core/services/personal.service';
import { AppErrorShow } from '../../../../../core/utils/app-error-show';
import { AppSweetAlert } from '../../../../../core/utils/app-sweet-alert';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SampleSearchPipe } from '../../../../../core/pipes/sample-search.pipe';
import { LoadingComponent } from '../../../../components/loading/loading.component';
import { HeaderComponent } from '../../../layout/includes/header/header.component';
import { NgxPaginationModule } from 'ngx-pagination';

@Component({
  selector: 'app-missing-personal',
  templateUrl: './missing-personal.component.html',
  imports: [CommonModule, FormsModule, NgbModule, LoadingComponent, SampleSearchPipe, HeaderComponent, NgxPaginationModule],
  styleUrls: ['./missing-personal.component.css']
})
export class MissingPersonalComponent {
  buttonsPermission: any;
  search_text = '';
  data: any[] = [];
  personals: any[] = [];
  selected_data: any;
  loading = false;

  form: any = this.emptyForm();

  readonly TYPES = ['absence', 'retard', 'maladie', 'autre'];

  pg = { pageSize: 10, p: 0, total: 0 };

  constructor(
    private absenceService: PersonalAbsenceService,
    private personalService: PersonalService,
    private toastrService: ToastrService,
    config: NgbModalConfig,
    private modalService: NgbModal
  ) {
    config.backdrop = 'static';
    config.keyboard = false;
  }

  ngOnInit(): void {
    this.buttonsPermission = { show: false, add: true, edit: true, delete: true, status: true };
    this.getAll();
    this.getPersonals();
  }

  emptyForm() {
    return { personal_id: null, date: new Date().toISOString().substring(0, 10), end_date: null, type: 'absence', reason: '', is_justified: false, status: '' };
  }

  getAll() {
    this.loading = true;
    this.absenceService.getAll().subscribe((res: any) => {
      this.loading = false;
      this.data = res.data ?? [];
      this.pg.total = this.data.length;
    }, (err: any) => { this.loading = false; AppErrorShow.showError('Gestion des absences', err); });
  }

  getPersonals() {
    this.personalService.getAll().subscribe((res: any) => { this.personals = res.data ?? []; }, () => {});
  }

  store(value: any) {
    this.loading = true;
    this.absenceService.store(value).subscribe((res: any) => {
      this.loading = false;
      this.toastrService.success(res.message);
      this.modalService.dismissAll();
      this.form = this.emptyForm();
      this.getAll();
    }, (err: any) => { this.loading = false; AppErrorShow.showError('Gestion des absences', err); });
  }

  update(value: any) {
    this.loading = true;
    this.absenceService.update(this.selected_data.id, value).subscribe((res: any) => {
      this.loading = false;
      this.toastrService.success(res.message);
      this.modalService.dismissAll();
      this.getAll();
    }, (err: any) => { this.loading = false; AppErrorShow.showError('Gestion des absences', err); });
  }

  delete() {
    if (!this.verifyChecked()) return;
    const confirmed = AppSweetAlert.confirmBox('info', 'Suppression', 'Voulez-vous vraiment supprimer cette absence ?');
    confirmed.then((result: any) => {
      if (result.isConfirmed) {
        this.absenceService.delete(this.selected_data.id).subscribe((res: any) => {
          this.toastrService.success(res.message);
          this.getAll();
        }, (err: any) => AppErrorShow.showError('Gestion des absences', err));
      }
    });
  }

  checked(el?: any) { this.selected_data = el; }

  verifyChecked() {
    if (this.selected_data == null) { this.toastrService.warning('Aucun élément sélectionné'); return false; }
    return true;
  }

  add(content: any) {
    this.form = this.emptyForm();
    this.modalService.open(content, { size: 'lg' });
  }

  edit(content: any) {
    if (!this.verifyChecked()) return;
    this.form = { ...this.selected_data };
    this.modalService.open(content, { size: 'lg' });
  }

  dismiss() { this.modalService.dismissAll(); }

  getPage(event: any) { this.pg.p = event; }

  personalName(p: any) { return p ? `${p.lastname} ${p.firstname}` : '—'; }

  typeLabel(t: string) {
    switch (t) {
      case 'absence': return 'Absence';
      case 'retard': return 'Retard';
      case 'maladie': return 'Maladie';
      case 'autre': return 'Autre';
      default: return t || '—';
    }
  }

  typeClass(t: string) {
    switch (t) {
      case 'absence': return 'bg-red-100 text-red-700';
      case 'retard': return 'bg-orange-100 text-orange-700';
      case 'maladie': return 'bg-blue-100 text-blue-700';
      default: return 'bg-gray-100 text-gray-600';
    }
  }
}
